<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 비상대응조치계획 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 비상대응조치계획</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="form-title">절차/시나리오명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.시나리오명 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.시나리오명" :max="300" :visible-counter="true"/>
        </div>

        <div>
          <div class="form-title">관리부서</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.관리부서 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.관리부서" :max="100" :visible-counter="true"/>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";

export default {
  components: {
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        시나리오명: "",
        관리부서: "",
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
